export default __webpack_public_path__ + "static/media/trr-drink-specialty-healthshot.6653a909.png";